export const ADMIN_GENERAL_SETTINGS_INFORMATION_ROUTE_NAME = Symbol('admin.settings.information');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_INFORMATION = Symbol('general-settings.information');

export const SETTINGS_INFORMATION_ITEM_URL = 'admin/static_pages/load_:page';
export const SETTINGS_INFORMATION_SAVE_URL = 'admin/static_pages/save_:page';

export const SETTINGS_INFORMATION_ITEM_QUERY_KEY = 'general-settings.information.item';
export const SETTINGS_INFORMATION_SAVE_QUERY_KEY = 'general-settings.information.save';
